import { redirect, type LoaderFunctionArgs, type RouteObject } from 'react-router';

/**
 * A page's old address (APP-234): it opens the page where it lives now with the same query
 * (`?stage=committee`, `?award=…`), so emails, bell notices, Teams messages, Help's links, the
 * assistant's links and saved bookmarks all still land. A route with no page of its own, so it
 * redirects in a preview too (`previewAware` keeps its loader).
 */
export function movedTo(path: string, target: string): RouteObject {
  return {
    path,
    loader: ({ request }: LoaderFunctionArgs) => {
      const url = new URL(request.url);
      return redirect(`${target}${url.search}${url.hash}`);
    },
  };
}
